import PropTypes from "prop-types";
import { CustomContainer } from "../../atoms/DependencyHelper";
import { componentCheckSize, componentResize } from "../../../utils/helperServices";
import styles from "./BrowseContainer.module.scss";

const BrowseContainer = (props) => {
	const isMobile = componentResize();
	const tabletSize = componentCheckSize();
	const isTablet = tabletSize < 992 && !isMobile;

	return (
		<CustomContainer
			className={props.hide ? styles["hide"] : styles["browse-container"]}
		>
			<CustomContainer
				className={`${props?.containerStyling} ${styles["browse-bar"]}`}
			>
				{isTablet && !props.selectionFlag && (
					<CustomContainer className={`${!props.selectionFlag ? '' : styles.line }`} />
				)}

				<div className="d-flex">
					<div className={`${styles["browse-heading"]} mb-0
						${props.heading != "Phones & SIM" ? styles["browse-heading-styling"] : ""}`} id="browse-heading">
						{props.heading}
					</div>
					<div>
						<CustomContainer className={`${styles["filter-button-tablet"]}`}>
							{props.filterButton}
						</CustomContainer>
						{props.searchFilterButton && (
							<CustomContainer className={`${styles["filter-button-tablet"]} ${styles["search-filter-tablet"]}`}>
								{props.searchFilterButton}
							</CustomContainer>
						)}
					</div>
				</div>

				{/* <p className={`${styles["browse-heading"]} mb-0
					${props.heading != "Phones & SIM" ? styles["browse-heading-styling"] : ""}`} id="browse-heading">
					{props.heading}
				</p> */}

				{!isTablet && (
					<p
						className={
							props.isDeal
								? styles["browse-deal-sub-heading"]
								: styles["browse-sub-heading"]
						}
						id="filter-subheader"
					>
						{props.shortDescription}
					</p>
				)}

				{/* <CustomContainer className={`${styles["filter-button-tablet"]}`}>
					{props.filterButton}
				</CustomContainer>
				{props.searchFilterButton && (
					<CustomContainer className={`${styles["filter-button-tablet"]} ${styles["search-filter-tablet"]}`}>
						{props.searchFilterButton}
					</CustomContainer>
				)} */}
			</CustomContainer>
		</CustomContainer>
	);
};

BrowseContainer.propTypes = {
	hide: PropTypes.bool,
	heading: PropTypes.string,
	containerStyling: PropTypes.string,
	filterButton: PropTypes.any,
	searchFilterButton: PropTypes.any,
};

export default BrowseContainer;